import { request } from '../helpers'
import accountEndpoints from './account'
import appointmentTypesEndpoints from './appointment_types'
import onDemandEndpoints from './ondemand'
import formsAndWaivers from './forms-and-waivers'
import featureFlagEndpoints from './feature_flags'
import scheduleEndpoints from './schedule'
import storeEndpoints from './store'
import leadEndpoints from './lead_form'

export default {
  ...accountEndpoints,
  ...featureFlagEndpoints,
  ...scheduleEndpoints,
  ...storeEndpoints,
  ...appointmentTypesEndpoints,
  ...onDemandEndpoints,
  ...formsAndWaivers,
  ...leadEndpoints,

  async listAttendances({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'attendances', queryParameters, expand })).data
  },

  async listCourseSessionAttendances({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'course_session_attendances', queryParameters, expand })).data
  },

  async listVenues({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'venues', queryParameters, expand })).data
  },

  async listOfferingTypeCategories({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'offering_type_categories', queryParameters, expand })).data
  },

  async listInstructors({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'instructors', queryParameters, expand })).data
  },

  async listEvents({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'events', queryParameters, expand })).data
  },

  async getWaiverAgreements({ expand = [], queryParameters = {} }) {
    return (await request({ url: 'waiver_agreements', queryParameters, expand })).data
  },

  async listOfferingTypes({ expand = [], queryParameters = {} } = {}) {
    return (await request({ url: 'offering_types', queryParameters, expand }))
      .data
  },

  async getMemberships({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({ url: 'memberships', queryParameters, expand })
    ).data
  },

  async getCalendarLinks(customerId) {
    if (!customerId) {
      console.warn('API: calendarLinks customerId is not defined!')
      return
    }
    return (await request({ url: `customers/${customerId}/icalendar_links` }))
      .data
  },

  async retrieveOfferingType(offeringTypeId, { expand = [] } = {}) {
    if (!offeringTypeId) {
      console.warn('API: retrieveOfferingType offeringTypeId is not defined!')
      return
    }
    return (await request({ url: `offering_types/${offeringTypeId}`, expand })).data
  },

  async retrieveCustomerMembership(id, { expand = [] } = {}) {
    if (!id) {
      console.warn('API: retrieveCustomerMembership: id is not defined!')
      return
    }
    return (
      await request({
        url: `customer_memberships/${id}`,
        expand,
      })
    ).data
  },

  async retrieveAttendances(id, { expand = [] } = {}) {
    if (!id) {
      console.warn('API: retrieveAttendances: id is not defined!')
      return
    }
    return (
      await request({
        url: `attendances/${id}`,
        expand,
      })
    ).data
  },
}
